import { render, staticRenderFns } from "./tsjTestTable.vue?vue&type=template&id=25b0da1c&scoped=true&"
import script from "./tsjTestTable.vue?vue&type=script&lang=js&"
export * from "./tsjTestTable.vue?vue&type=script&lang=js&"
import style0 from "./tsjTestTable.vue?vue&type=style&index=0&id=25b0da1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0da1c",
  null
  
)

export default component.exports